import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { useLanguage } from "@/context/AppContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Contact() {
  const { t } = useLanguage();
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);

  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/enquiries`, { ...form, subject: "General" });
      toast.success(t.contact.success);
      setForm({ name: "", email: "", message: "" });
    } catch {
      toast.error(t.contact.error);
    } finally {
      setSending(false);
    }
  };

  return (
    <section id="contact" className="section contact" data-testid="contact-section">
      <div className="section-label">{t.contact.label}</div>
      <div className="contact-grid">
        <div>
          <h2 data-testid="contact-section-title">
            {t.contact.l1}
            <br />
            <em>{t.contact.l2}</em>
          </h2>
          <p>{t.contact.p}</p>
        </div>
        <form onSubmit={submit} data-testid="contact-form">
          <label>
            {t.contact.name}
            <input data-testid="contact-name-input" required minLength={2} placeholder={t.contact.namePh} value={form.name} onChange={set("name")} />
          </label>
          <label>
            {t.contact.email}
            <input data-testid="contact-email-input" type="email" required placeholder={t.contact.emailPh} value={form.email} onChange={set("email")} dir="ltr" />
          </label>
          <label>
            {t.contact.message}
            <textarea data-testid="contact-message-textarea" required minLength={5} rows={5} placeholder={t.contact.msgPh} value={form.message} onChange={set("message")} />
          </label>
          <button className="btn primary" type="submit" data-testid="contact-submit-button" disabled={sending}>
            {sending ? t.contact.sending : t.contact.send}
          </button>
        </form>
      </div>
    </section>
  );
}
